module.exports = __webpack_public_path__ + "img/classiccar.ac7c4f6c.webp";